/*
 *
 * Subscription Plans reducer
 *
 */
import { get } from 'lodash';

import {
  FETCH_SUBSCRIPTION_PLANS,
  FETCH_SUBSCRIPTION_PLANS_FAILED,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  BILLING_IDS,
} from 'containers/SubscriptionPlans/constants';

export const initialState = {
  plans: {
    isFetching: false,
    plans: false,
    error: false,
  },
  pricingPlans: [],
  selectedBillingCycle: BILLING_IDS.yearly,
};

function subscriptionPlansReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS:
      return Object.assign({}, state, {
        plans: {
          isFetching: true,
          plans: false,
          error: false,
        },
      });
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS: {
      let plans = get(action, 'plans', false);
      if (plans) {
        plans = plans.map((plan) => {
          // this code was added to handle the conversion
          // of enterprise plans to elite (RES-4745)
          // a similar change on the backend/stripe data
          // would make this code obsolete
          const { alias = '' } = plan;
          return {
            ...plan,
            alias: alias.replace(/enterprise/gim, 'elite'),
          };
        });
      }
      return Object.assign({}, state, {
        plans: {
          isFetching: false,
          plans,
          error: false,
        },
      });
    }
    case FETCH_SUBSCRIPTION_PLANS_FAILED:
      return Object.assign({}, state, {
        plans: {
          isFetching: false,
          plans: false,
          error: action.error || false,
        },
      });
    default:
      return state;
  }
}

export default subscriptionPlansReducer;
